import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Col, Table, Row, Divider, Typography, Spin } from 'antd';
import { ExcelIcon } from 'icons';
import { Link } from 'react-router-dom';
import Filters from 'components/filters';
import { useTranslation } from 'react-i18next';
import useKpiWeekdaysHolidays from '../useKpiWeekdaysHolidays';
import BarChangeChart from '../../../charts/barChange';
import AlertMessage from '../../../components/alertMessage';
import UIHelper from '../../../../../helpers/UIHelper';

const MainPage = () => {
  const {
    data,
    columns,
    filters,
    title,
    loading,
    handleDownloadExcel,
    searchParams,
    loadingPdf,
    handleDownloadPdf,
    errors,
    columns2,
  } = useKpiWeekdaysHolidays();
  const { t } = useTranslation();

  return (
    <>
      <PageHeader title={t('KPIs by DAY TYPE').toUpperCase()}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              icon={<ExcelIcon fill={'#fff'} />}
              onClick={handleDownloadExcel}
              loading={loading}
            >
              {t('Export')}
            </Button>
          </Col>
          <Col>
            <Button
              loading={loadingPdf}
              onClick={() => handleDownloadPdf(title)}
              big
              icon={<PlusOutlined />}
            >
              {t('Stampa')}
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters filters={filters} />
        <br />
        <AlertMessage errors={errors} searchParams={searchParams} />
        <Spin spinning={loading}>
          <Row className={styles.titleSection} justify={'center'}>
            <Col>
              <Typography.Title level={3}>{title}</Typography.Title>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <BarChangeChart
                keys={data.keys}
                data={data}
                hideLine
                // format={format}
              />
            </Col>
            <Divider />
            <Col span={24}>
              <Table
                columns={UIHelper.assignTire(columns)}
                dataSource={data.table1}
                pagination={{
                  pageSize: 10,
                  position: ['bottomCenter'],
                  hideOnSinglePage: true,
                  showSizeChanger: false,
                }}
                bordered
                scroll={{ x: 900 }}
              />
            </Col>
            <Col span={24}>
              <Table
                columns={UIHelper.assignTire(columns2)}
                dataSource={data.table2}
                pagination={{
                  pageSize: 10,
                  position: ['bottomCenter'],
                  hideOnSinglePage: true,
                  showSizeChanger: false,
                }}
                bordered
                scroll={{ x: 900 }}
              />
            </Col>
            <Col span={24}>
              <Table
                columns={UIHelper.assignTire(columns)}
                dataSource={data.table3}
                pagination={{
                  pageSize: 10,
                  position: ['bottomCenter'],
                  hideOnSinglePage: true,
                  showSizeChanger: false,
                }}
                bordered
                scroll={{ x: 900 }}
              />
            </Col>
            <Col span={24}>
              <Table
                columns={UIHelper.assignTire(columns)}
                dataSource={data.table4}
                pagination={{
                  pageSize: 10,
                  position: ['bottomCenter'],
                  hideOnSinglePage: true,
                  showSizeChanger: false,
                }}
                bordered
                scroll={{ x: 900 }}
                // showHeader={false}
              />
            </Col>
          </Row>
        </Spin>
      </div>
    </>
  );
};

export default MainPage;
